import type { CountryCode, CrossBorderReceiver, CrossBorderReceiverRequest } from '../../generated-types';

const createUpdateCrossBorderReceiverRequest = (
    receiver: CrossBorderReceiver,
    receiverAddress: string,
    receiverAddress2: string,
    receiverPostCode: string,
    receiverTown: string,
    receiverName: string,
    receiverCountryCode: CountryCode | undefined,
): CrossBorderReceiverRequest => {
    return {
        account: receiver.account,
        address: receiverAddress === '' ? undefined : receiverAddress,
        address2: receiverAddress2 === '' ? ' ' : receiverAddress2,
        town: receiverTown === '' ? undefined : receiverTown,
        postcode: receiverPostCode === '' ? undefined : receiverPostCode,
        bank: receiver.bank,
        name: receiverName,
        countryCode: receiverCountryCode,
    };
};

export default createUpdateCrossBorderReceiverRequest;
